<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "../resource/css/leaflet.css";
import "../resource/js/leaflet/leaflet.js";
import "leaflet-polylinedecorator";
export default {
  name: "App"
};
</script>

<style>
@import "./assets/fonts/fonts.css";
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}

html,
body {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue